import React,{useState} from "react";
import { For, HStack, Checkbox, Stack,CheckboxGroup } from "@chakra-ui/react"

export default function DotRadio(props) { 
    const {baseColor,tickColor,slug} = props

    return (
        <>
            <Checkbox.Root variant="outline" key={slug} value={slug}>
                <Checkbox.HiddenInput />
                <Checkbox.Control
                    rounded="full"
                    p="0"       
                    boxSize="6"
                    borderColor={baseColor}
                    borderWidth="1.5px"
                    borderStyle="dotted"
                >
                    <Checkbox.Indicator color={tickColor} zIndex={1} boxSize={3}/>
                    <Checkbox.Indicator
                        w="1.15rem" h="1.15rem"
                        rounded="full"
                        borderColor={baseColor}
                        bg={baseColor}
                        position="absolute"
                        color="transparent"            
                    />
                </Checkbox.Control>
            </Checkbox.Root>
        </>
    )
} 